<template>
  <el-card shadow="hover" class="console no-padding">
    <div slot="header">
      <i class="mdi mdi-fullscreen" @click="fullscreen = true" />
      <i class="mdi mdi-console" /> Live logs
    </div>

    <Terminal
      v-if="connect"
      :logs="logs"
      :offset="offset"
      :fullscreen.sync="fullscreen"
    />

    <el-button v-else size="small" @click="connect = true">
      Connect to console
    </el-button>
  </el-card>
</template>

<script>
import Terminal from '../Terminal'
import _ from 'lodash'

export default {
  props: {
    application: Object,
    offset: {
      type: Number,
      default: 0
    }
  },
  components: {
    Terminal
  },
  data () {
    return {
      connect: false,
      fullscreen: false,
      event: null,
      logs: []
    }
  },
  beforeDestroy () {
    this.close()
  },
  methods: {
    close () {
      if (this.event) {
        this.event.close()
        this.event = null
      }
    },
    load () {
      this.close()

      this.logs = []
      this.event = this.$sse.channel(this.application.instanceId + '/app-' + this.application.name)
      this.event.addEventListener('message', (ev) => this.logs.push(ev.data))

      this.$store.dispatch('getApplicationConsole', this.application)
        .then((res) => {
          this.logs = _.concat(res.data, this.logs)
        }).catch(() => this.$notify({
          type: 'error',
          title: 'Unable to retrieve console log'
        }))
    }
  },
  watch: {
    connect (value) {
      if (value) {
        this.load()
      }
    },
    application () {
      this.connect = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .mdi-fullscreen {
    float: right;
    margin-top: -5px;
    font-size: 22px;
    cursor: pointer;
  }
  .el-button {
    margin: 12px auto;
    display: block;
  }
</style>
